var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4443 2.13879H21.1943V17.861H12.4443V2.13879Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 9.99999C12.9993 6.8056 14.4993 3.97221 16.8048 2.13883C15.1105 0.805526 12.9716 0 10.6383 0C5.11034 0 0.638184 4.47215 0.638184 9.99999C0.638184 15.5277 5.11034 20 10.6382 20C12.9715 20 15.1103 19.1945 16.8048 17.861C14.4993 16.0555 12.9993 13.1944 12.9993 9.99999Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9996 9.99995C32.9996 15.5277 28.5274 19.9999 22.9996 19.9999C20.6663 19.9999 18.5274 19.1944 16.833 17.861C19.1663 16.0277 20.6386 13.1943 20.6386 9.99995C20.6386 6.80556 19.1385 3.97217 16.833 2.1388C18.5273 0.805488 20.6663 -3.8147e-05 22.9996 -3.8147e-05C28.5274 -3.8147e-05 32.9996 4.49995 32.9996 9.99995Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.094d456a70dae7f10d17c7b068741398.svg";
export { ForwardRef as ReactComponent };